import {
    FETCH_PERMISSION_REQUEST,
    FETCH_PERMISSION_SUCCESS,
    FETCH_PERMISSION_FAILURE,
  } from "./FetchPermissionsTypes";
  
  const initialState = {
    loading: false,
    permissionsData: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PERMISSION_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_PERMISSION_SUCCESS:
        return {
          loading: false,
          permissionsData: action.payload,
          error: "",
        };
      case FETCH_PERMISSION_FAILURE:
        return {
          loading: false,
          permissionsData: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  